import {Component, inject, OnInit} from '@angular/core';
import {IonContent} from '@ionic/angular/standalone';
import {BlogService} from './blog.service';
import {PostCardComponent} from './common/post-card/post-card.component';
import {HeaderComponent} from '../common/header/header.component';
import {FooterComponent} from '../common/footer/footer.component';
import {SubscribeBannerComponent} from '../properties/common/subscribe-banner/subscribe-banner.component';
import {ActivatedRoute} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    PostCardComponent,
    HeaderComponent,
    FooterComponent,
    SubscribeBannerComponent
  ]
})
export class BlogComponent  implements OnInit {
  blogService: BlogService = inject(BlogService);
  route: ActivatedRoute = inject(ActivatedRoute);
  posts: any = [];
  constructor() { }

  title: Title = inject(Title);
  meta: Meta = inject(Meta);
  async ngOnInit() {

    this.title.setTitle('Satel Real Estate Blog in Riyadh');

    this.meta.addTags([
      {property: 'og:title', content: 'Satel Real Estate Blog in Riyadh'},
      {name: 'description', content: 'Stay informed about the latest trends in the Riyadh real estate market. Our blog features valuable insights, tips for homebuyers and sellers, and expert advice from our team.'},
      {property: 'og:description', content: 'Stay informed about the latest trends in the Riyadh real estate market. Our blog features valuable insights, tips for homebuyers and sellers, and expert advice from our team.'},
      {property: 'og:image', content: 'https://satel-resources.nyc3.digitaloceanspaces.com/posts/f26618db-6b8a-47c0-b32d-ddcd301c8758.png'},
      {property: 'og:site_name', content: 'satel.sa'},
      {property: 'og:url', content: `https://satel.sa/`},
      {property: 'og:type', content: 'article'},
      {name: 'twitter:site', content: 'satel.sa'},
      {name: 'twitter:title', content: 'Satel Real Estate Blog in Riyadh'},
      {name: 'twitter:description', content: 'Stay informed about the latest trends in the Riyadh real estate market. Our blog features valuable insights, tips for homebuyers and sellers, and expert advice from our team.'},
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:image', content: 'https://satel-resources.nyc3.digitaloceanspaces.com/posts/f26618db-6b8a-47c0-b32d-ddcd301c8758.png'}
    ]);
    this.route.params.subscribe(async params => {
      if (params['type']) {}
      this.posts = await this.blogService.getAllPosts(params['type'] ?? 'post');
    })
  }

}
